export default "__VITE_ASSET__04e6fffc__"